module.exports = __webpack_public_path__ + "img/383.e8448f61.jpg";